import React, {Component} from "react"
import {Row} from "@irati/ui/src/Layout"
import {Reward} from "@irati/types"
import styled, {css} from "styled-components"
import {connect} from "react-redux"
import {get} from "lodash"

import {FormattedMessage} from "@irati/utils/lang"
import getId from "@irati/utils/id"
import Slider from "@irati/ui/src/Slider"
import {minWidthMedia, DESKTOP, TABLET} from "@irati/ui/src/global/media"
import {H3} from "@irati/ui/src/Typography"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {DisablePointerEventsOnScroll} from "@irati/ui/src/DisablePointerEventsOnScroll"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"

import CustomTile from "../CustomReward/Tile"
import RewardTile from "../Tile"

const TileContainer = styled.div`
  ${({theme}) => css`
    padding: 0 5px;
    ${minWidthMedia.tablet`
      padding: 0 ${theme.spacing.one};
    `}
  `}
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

const BodyRow = styled(Row)`
  margin-bottom: ${({theme}) => theme.spacing.five};
`

interface Props {
  isFirst: boolean
  id: string
  title: string
  data: Reward[]
  isMobile: boolean
}

class FeedSlider extends Component<Props> {
  render() {
    const {id, isFirst, title, data, isMobile} = this.props

    const moreThanOneFeedItem = data.length > 1
    const sliderSettings = {
      centerMode: moreThanOneFeedItem && isMobile,
      infinite: moreThanOneFeedItem && isMobile,
      draggable: moreThanOneFeedItem && isMobile,
      centerPadding: "30px",
      responsive: [
        {breakpoint: TABLET, settings: {slidesToShow: 1, slidesToScroll: 1}},
        {breakpoint: DESKTOP, settings: {slidesToShow: 2, slidesToScroll: 2}}
      ]
    }

    return data.length === 0 ? null : (
      <>
        <Flex justifyContent="space-between" alignItems="center" marginTop={2} marginBottom={2}>
          <H3>{title}</H3>
          <ButtonsContainer>
            <ButtonRouterLink tertiary cta id={getId("link", this.props)} to="/reward/all">
              <Flex alignItems="center">
                <FormattedMessage id="reward.homepage.links.allrewards" />
                <Icon icon={IconTypes.arrowRight} marginLeft />
              </Flex>
            </ButtonRouterLink>
          </ButtonsContainer>
        </Flex>
        <BodyRow>
          <DisablePointerEventsOnScroll>
            <Slider id={id} className="feed-slider" settings={sliderSettings}>
              {isFirst && (
                <TileContainer>
                  <CustomTile />
                </TileContainer>
              )}

              {data.map((reward, index) => (
                <TileContainer key={reward.uuid}>
                  <RewardTile id={getId(`reward-${index}`, this.props)} reward={reward} />
                </TileContainer>
              ))}
            </Slider>
          </DisablePointerEventsOnScroll>
        </BodyRow>
      </>
    )
  }
}

const mapStateToProps = ({mq}) => {
  return {
    isMobile: get(mq, "lessThan.medium", false)
  }
}

export default connect(mapStateToProps)(FeedSlider)
